// --------------------- Import Globais ---------------------
import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Row,
  Button,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

// --------------------- Import Styles ---------------------
import { Container } from "./styles";
// --------------------- Import Hooks ---------------------

// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";

// --------------------- Import Uteis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useBuscarPeriodos } from "./hooks/useBuscarPeriodos";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import ModalAdicionar from "./components/ModalAdicionar";
import ModalEditar from "./components/ModalEditar";

export default function ViewGerenciarPeriodos() {
  const [queryParams] = useQueryParams({
    cotaId: NumberParam,
    numeroCota: NumberParam,
    aptoId: NumberParam,
    empreendId: NumberParam,
    aptoNome: StringParam,
    empreendNome: StringParam,
  });
  const cotaId = queryParams.cotaId;
  const numeroCota = queryParams.numeroCota;
  const aptoId = queryParams.aptoId;
  const empreendId = queryParams.empreendId;
  const aptoNome = queryParams.aptoNome;
  const empreendNome = queryParams.empreendNome;
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const isMobile = useMediaQuery("(max-width:600px)");

  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO
  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading } = usePermissao("OPE");

  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  const { periodos, isLoading } = useBuscarPeriodos(cotaId);

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Editar
      case "1":
        editModal();
        break;

      case "2":
        // Excluir

        break;
    }
  };

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    checkIn?: string[] | null;
    checkOut?: string[] | null;
    dataEspecial?: string[] | null;
    origem?: string[] | null;
    valor?: string[] | null;
  }>({
    checkIn: null,
    checkOut: null,
    dataEspecial: null,
    origem: null,
    valor: null,
  });

  const [semFiltros, setSemFiltros] = useState(true);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        checkIn: novoFiltro.checkIn ? [novoFiltro.checkIn] : null,
        checkOut: novoFiltro.checkOut ? [novoFiltro.checkOut] : null,
        dataEspecial: novoFiltro.dataEspecial
          ? [novoFiltro.dataEspecial]
          : null,
        origem: novoFiltro.origem ? [novoFiltro.origem] : null,
        valor: novoFiltro.valor ? [novoFiltro.valor] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      checkIn: filters.checkIn as string[] | null,
      checkOut: filters.checkOut as string[] | null,
      dataEspecial: filters.dataEspecial as string[] | null,
      origem: filters.origem as string[] | null,
      valor: filters.valor as string[] | null,
    });

    const hasFilters = Boolean(
      filters.checkIn ||
        filters.checkOut ||
        filters.dataEspecial ||
        filters.origem
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({
      checkIn: null,
      checkOut: null,
      dataEspecial: null,
      origem: null,
      valor: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  const [isModalAddOpen, setIsModalAddOpen] = useState(false);

  // Funçao para abrir o modal (Adicionar Periodo)
  const addModal = () => {
    setIsModalAddOpen(true);
  };

  // Funçao para fechar o modal (Periodo)
  const handleAddFechar = () => {
    setIsModalAddOpen(false);
  };

  const [isModalEditOpen, setIsModalEditOpen] = useState(false);

  // Funçao para abrir o modal (Editar Periodo)
  const editModal = () => {
    setIsModalEditOpen(true);
  };

  // Funçao para fechar o modal (Periodo)
  const handleEditFechar = () => {
    setIsModalEditOpen(false);
  };

  const [periodoId, setPeriodoId] = useState<number | null>(null);
  const [dataEspecial, setDataEspecial] = useState<string | null>(null);
  const [valor, setValor] = useState<string | null>(null);
  const [checkIn, setCheckIn] = useState<string | null>(null);
  const [checkOut, setCheckOut] = useState<string | null>(null);

  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(
    onClick,
    setPeriodoId,
    setDataEspecial,
    setValor,
    setCheckIn,
    setCheckOut,
    {
      checkIn: filteredInfo.checkIn,
      checkOut: filteredInfo.checkOut,
      dataEspecial: filteredInfo.dataEspecial,
      origem: filteredInfo.origem,
      valor: filteredInfo.valor,
    }
  );

  return (
    <>
      {isLoading && isTokenLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a
                  href={`/gerenciarCotas/?aptoId=${aptoId ?? ""}&&aptoNome=${
                    aptoNome ?? ""
                  }&&empreendNome=${empreendNome ?? ""}&&empreendId=${
                    empreendId ?? ""
                  }`}
                >
                  <ArrowBackIcon color="primary" />
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />

                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Períodos da cota nº {numeroCota} do {empreendNome}
                </Title>
              </Flex>
            </Col>
            <Col span={7}>
              <Flex
                align="center"
                justify="flex-end"
                style={{
                  marginTop: 15,
                  marginRight: isMobile ? 20 : 55,
                }}
              >
                <Button
                  onClick={() => {
                    addModal();
                  }}
                  type="primary"
                >
                  + Periodo
                </Button>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "auto",
                marginLeft: isMobile ? 300 : "1200px",
              }}
            >
              {semFiltros ? (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  disabled={true}
                  style={{ marginBottom: 8 }}
                >
                  <FilterAltIcon />
                </Button>
              ) : (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  style={{ marginBottom: 8 }}
                >
                  <FilterAltOffIcon />
                </Button>
              )}
            </div>
            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 15,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={periodos}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalAdicionar
            isModalOpen={isModalAddOpen}
            handleFechar={handleAddFechar}
            cotaId={cotaId}
          />
          <ModalEditar
            isModalOpen={isModalEditOpen}
            handleFechar={handleEditFechar}
            cotaId={cotaId}
            periodoId={periodoId}
            dataEspecial={dataEspecial}
            valor={valor}
            checkIn={checkIn}
            checkOut={checkOut}
          />
        </Container>
      )}
    </>
  );
}
